<template>
    <div>
        <div class="view">

            <Head @ck="menuOpen = true">{{headTil}}</Head>
            <div class="page">
                <TurnCard :info="word" :notag="false" :tag="isTag" @tag="chgTag"></TurnCard>
                <div class="cont">
                    <div class="des">{{word.Desricption}}</div>
                    <!-- <div class="chi-des">{{word.ChineseDefinition}}</div> -->
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Lazy from 'lazy.js'
import TurnCard from '@/components/TurnCard'
import mainDelegate from '@/delegate/mainDelegate'
import myNoteDelegate from '@/delegate/myNoteDelegate'
export default {
    name: 'AnWord',
    mixins: [mainDelegate, myNoteDelegate],
    data() {
        return {
            headTil: ''
        }
    },
    computed: {
        isTag() {
            let id = this.word.Id
            return Lazy(this.nodeIdList).find(noteId => {
                return noteId === id
            })
                ? true
                : false
        }
    },
    components: {
        TurnCard
    },
    methods: {
        chgTag(val) {
            switch (val.tag) {
                case 'add':
                    this.addVocabularyToNote(val.Id)
                    break
                case 'remove':
                    this.removeVocabularyToNote(val.Id)
                    break
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        /* 由學習記錄進去標題就秀，每日單字 */
        next(vm => {
            if (from.name === 'mydoc') {
                vm.headTil = vm.$t('menu.toWord')
            }
        })
    }
}
</script>

<style lang="less" scoped>
@import 'val.less';
@import 'view.less';
.cont {
    width: auto;
    margin: 23px 16px 0px 16px;
    text-align: left;
    font-size: 18px;
    letter-spacing: 0.1em;
    .des {
        margin-bottom: 35px;
    }
}
@media only screen and (min-width: @rwd) {
    .page {
        display: flex;
    }
    .cont {
        width: 480px;
        margin-left: 90px;
        text-align: left;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/AnWord.vue